<template>
	<div class="message-item">
		<!-- 用户消息 -->
		<div v-if="message.role === 'user'" class="chat-content-query">
			<div class="user-message-wrapper">
				<div v-if="message.content" style="margin-bottom: 8px">
					<!-- {{ message.content }} -->
					<div class="message-bubble user-bubble">
						<div ref="userQuestionRef" class="user-question-text" :class="{ 'user-bubble-clamped': !message.questionExpanded }">
							<vue-markdown :breaks="true" :html="true" :source="message.content" :tables="true"></vue-markdown>
						</div>
						<!-- 问题过长时展示 展开/收起（位于气泡内左下角） -->
						<div v-if="message.questionOverflow" class="user-question-toggle" @click="toggleQuestionExpand">
							{{ message.questionExpanded ? '收起' : '展开' }}
							<i :class="message.questionExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
						</div>
					</div>
				</div>
				<!-- 用户上传图片展示 -->
				<div class="user-images-container" v-if="message.imageList && message.imageList.length > 0">
					<div class="user-image-card" v-for="(img, index) in message.imageList" :key="index">
						<img :src="img.url" alt="图片" title="点击图片可放大" @click.stop="handleEnlargeImage(img.url)" />
					</div>
				</div>
				<div class="book-tags-container" v-if="message.historyBookList && message.historyBookList.length > 0">
					<el-tag v-for="book in message.historyBookList" :key="book.value" type="info" class="book-tag">
						<i class="el-icon-collection"></i>
						<span class="book-tag-text">{{ book.catalog_type == 0 ? '企业知识库' : book.catalog_type == 1 ? '个人知识库' : '法规标准库' }} /</span>
						{{ book.name }}
					</el-tag>
				</div>
				<div class="chat-content-answer-tools" style="text-align: right">
					<el-tooltip class="item" effect="dark" content="复制" placement="bottom">
						<span class="chat-content-answer-tools-time" style="margin-right: 0" @click="copyMessageTitle">
							<i :class="message.copied ? 'icon-check-circle' : 'icon-file-copy'" class="iconfont"></i>
						</span>
					</el-tooltip>
				</div>
			</div>
			<div class="avatar avatar-user">
				<span class="avatar-text">{{ avatarText }}</span>
			</div>
		</div>

		<!-- 助手消息 -->
		<div v-else-if="message.role === 'assistant'" class="chat-content-answer">
			<div class="avatar avatar-ai">
				<i class="iconfont icon-aliwangwang-o avatar-ai-icon" style="font-size: 20px;"></i>
			</div>
			<div class="assistant-message-wrapper">
				<!-- 思考状态/查看思考过程 -->
				<div class="flex" style="cursor: pointer; margin-bottom: 8px; align-items: center">
					<div>
						<div v-if="message.isThinking" class="thinking-status" @click="$emit('toggle-content', message.id)">
							<div class="thinking-indicator" :class="{ 'is-paused': message.isPause }">
								<span class="thinking-text">{{ message.isPause ? '已暂停' : '正在思考' }}</span>
								<span class="thinking-dots"><i></i><i></i><i></i></span>
							</div>
						</div>
						<div v-else-if="message.hasThought" class="thought-status" @click="$emit('toggle-content', message.id)">
							<div class="thought-indicator">
								<span class="thought-text">{{ message.isPause ? '已暂停' : '已思考' }}</span>
							</div>
						</div>
					</div>

					<div class="content-header" @click="$emit('toggle-content', message.id)" v-if="message.thinking_process && message.thinking_process.length > 0">
						<span>查看思考过程</span>
						<span class="collapse-icon">
							<i :class="message.showAdditionalContent ? 'el-icon-caret-bottom' : 'el-icon-caret-right'" class="el-icon-collapse"></i>
						</span>
					</div>

					<span class="chat-content-answer-created-time" v-if="message.createTime">
						{{ message.createTime }}
					</span>
				</div>

				<div v-show="!message.errorStr && (message.showStatusText || message.showAdditionalContent || message.mainContent)" class="message-bubble ai-bubble">
					<!--显示状态（无思考过程时独立显示）-->
					<div v-show="message.showStatusText && !(message.thinking_process && message.thinking_process.length > 0)" class="typing-indicator">
						<span class="loading-text" v-html="message.showStatusText"></span>
					</div>
					<!-- 思考过程（内联展开，包含状态文本） -->
					<div style="position: relative; font-size: 13px; color: #b1666b" v-if="message.thinking_process && message.thinking_process.length > 0" class="addi-cont">
						<transition name="collapse">
							<div v-show="message.showAdditionalContent" class="content-body">
								<div v-if="message.showStatusText" class="typing-indicator" style="margin-bottom: 8px">
									<span class="loading-text" v-html="message.showStatusText"></span>
								</div>
								<div class="content-icon"></div>
								<vue-markdown class="main-cont" :breaks="true" :html="true" :source="message.thinking_process" :tables="true"> </vue-markdown>
							</div>
						</transition>
					</div>

					<!-- 主要内容 -->
					<vue-markdown v-if="message.mainContent" :breaks="true" :html="true" :source="message.mainContent" :tables="true"> </vue-markdown>
				</div>

				<!-- 工具栏 -->
				<div class="chat-content-answer-tools">
					<div v-if="message.errorStr">
						<p><i class="el-icon-warning" style="color: #f56c6c; font-size: 20px; margin-right: 6px"></i>{{ message.errorStr }}</p>
						<span v-if="(message.errorStr || message.isPause) && isLast" class="chat-content-answer-tools-time answer-tools-regenerate" title="重新生成" @click="$emit('regenerate', message.id)">
							重新生成
						</span>
					</div>

					<div v-show="!message.isTyping && !message.errorStr">
						<el-tooltip class="item" effect="dark" content="复制" placement="bottom">
							<span class="chat-content-answer-tools-time" @click="copyMessage" :class="{ 'answer-tools-disabled': !uisLogin }">
								<i :class="message.toolStatus.copied ? 'icon-check-circle' : 'icon-file-copy'" class="iconfont"></i>
							</span>
						</el-tooltip>
						<el-tooltip class="item" effect="dark" content="喜欢" placement="bottom">
							<span class="chat-content-answer-tools-time" @click="$emit('feedback', message.id, 10)" :class="{ 'answer-tools-disabled': !uisLogin }">
								<i :class="message.toolStatus.liked ? 'icon-like-fill' : 'icon-like'" class="iconfont"></i>
							</span>
						</el-tooltip>
						<el-tooltip class="item" effect="dark" content="不喜欢" placement="bottom">
							<span class="chat-content-answer-tools-time" @click="$emit('feedback', message.id, 0)" :class="{ 'answer-tools-disabled': !uisLogin }">
								<i :class="message.toolStatus.disliked ? 'icon-unlike-fill' : 'icon-unlike'" class="iconfont"></i>
							</span>
						</el-tooltip>

						<span v-if="(message.errorStr || message.isPause) && isLast" class="chat-content-answer-tools-time answer-tools-regenerate" title="重新生成" @click="$emit('regenerate', message.id)">
							重新生成
						</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import VueMarkdown from 'vue-markdown';
	import 'katex/dist/katex.min.css';
	import CopyText from '@/utils/CopyText';
	import TMessage from '@/utils/TMessage';

	export default {
		name: 'ChatMessage',
		components: {
			VueMarkdown
		},
		props: {
			message: {
				type: Object,
				required: true
			},
			isLast: {
				type: Boolean,
				default: false
			},
			uisLogin: {
				type: Boolean,
				default: false
			},
			uinfo: {
				type: Object,
				default: () => ({})
			}
		},
		computed: {
			avatarText() {
				const name = this.uinfo && this.uinfo.nickName ? this.uinfo.nickName : this.uinfo.realName ? this.uinfo.realName : 'U';
				return name.length <= 2 ? name : name.slice(-2);
			}
		},
		mounted() {
			if (this.message.role !== 'user') return;
			this.checkQuestionOverflow();
			window.addEventListener('resize', this.checkQuestionOverflow);
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.checkQuestionOverflow);
		},
		watch: {
			'message.content'() {
				if (this.message.role === 'user') {
					this.checkQuestionOverflow();
				}
			}
		},
		methods: {
			// 问题过长时切换展开/收起
			toggleQuestionExpand() {
				this.$set(this.message, 'questionExpanded', !this.message.questionExpanded);
			},
			// 检测问题内容是否超过5行（仅在收起状态下检测）
			checkQuestionOverflow() {
				if (this.message.questionExpanded) return;
				this.$nextTick(() => {
					const el = this.$refs.userQuestionRef;
					if (!el) return;
					const dom = el.$el || el;
					const overflow = dom.scrollHeight > dom.clientHeight + 1;
					if (overflow !== this.message.questionOverflow) {
						this.$set(this.message, 'questionOverflow', overflow);
					}
				});
			},
			// 点击图片放大预览
			handleEnlargeImage(src) {
				if (window.EReg && window.EReg.enlargeImage) {
					window.EReg.enlargeImage(src);
				}
			},
			copyMessageTitle() {
				this.message.copied = true;
				CopyText.copyMessage(this.message.content);
				setTimeout(() => {
					this.message.copied = false;
				}, 1000);
			},
			copyMessage() {
				if (!this.uisLogin) {
					TMessage.warning('请先登录，体验更多功能');
					return;
				}
				this.message.toolStatus.copied = true;
				CopyText.copyMessage(this.message.mainContent);
				setTimeout(() => {
					this.message.toolStatus.copied = false;
				}, 1000);
			}
		}
	};
</script>

<style lang="less" scoped>
	// 头像样式
	.avatar {
		width: 40px;
		height: 40px;
		border-radius: 12px;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
	}

	.avatar-user {
		background: linear-gradient(135deg, #3b82f6, #6366f1);
		color: #fff;
		font-size: 18px;
	}

	.avatar-ai {
		background: linear-gradient(135deg, #3b82f6, #6366f1);
		color: #fff;
		font-size: 18px;
	}

	.avatar-ai-icon {
		display: inline-block;
		transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
		cursor: default;

		&:hover {
			transform: scale(1.25) rotate(8deg);
		}
	}

	.avatar-text {
		color: #fff;
		font-size: 14px;
		font-weight: 600;
	}

	// 消息气泡样式
	.message-bubble {
		padding: 12px 16px;
		border-radius: 16px;
		font-size: 14px;
		line-height: 1.625;
		word-break: break-word;
	}

	.user-bubble {
		color: #0f1115;
		background: #dbeafe;
	}

	// 问题内容过长时收起态：限制5行（无内边距容器，确保精确截断5行）
	.user-bubble-clamped {
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 5;
		line-clamp: 5;
		overflow: hidden;
	}

	// 展开/收起 切换（位于问题框左下角）
	.user-question-toggle {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		gap: 2px;
		margin-top: 4px;
		font-size: 13px;
		color: #155dfc;
		cursor: pointer;
		user-select: none;

		&:hover {
			color: #409eff;
		}

		i {
			font-size: 12px;
		}
	}

	::v-deep .user-bubble p {
		margin: 0 !important;
		padding: 0 !important;
	}

	.ai-bubble {
		background: #fff;
		border: 1px solid #e2e8f0;
		color: #1e293b;
		box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
	}

	// 助手消息容器
	.chat-content-answer {
		display: flex;
		gap: 12px;
		margin: 20px 0;
		margin-bottom: 0;
	}

	.assistant-message-wrapper {
		flex: 1;
		min-width: 0;
	}

	.user-message-wrapper {
		max-width: 80%;
	}

	// 用户上传图片容器
	.user-images-container {
		display: flex;
		flex-wrap: wrap;
		gap: 8px;
		margin-bottom: 8px;
	}

	.user-image-card {
		width: 80px;
		height: 80px;
		border-radius: 8px;
		overflow: hidden;
		border: 1px solid #e2e8f0;
		cursor: pointer;

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
			transition: transform 0.2s;

			&:hover {
				transform: scale(1.05);
			}
		}
	}

	// 书单标签容器样式
	.book-tags-container {
		margin: 0 auto;
		display: flex;
		flex-wrap: wrap;
		gap: 8px;
		padding: 10px 0 0;

		.book-tag {
			margin: 0;
			font-size: 14px;
			color: #606266;
		}
	}

	.chat-content-query {
		display: flex;
		font-size: 14px;
		justify-content: flex-end;
		align-items: flex-start;
		gap: 12px;
		margin: 16px 0;
	}

	.chat-content-answer-tools {
		margin-top: 10px;

		.iconfont {
			font-size: 20px;
		}
	}

	.chat-content-answer-tools-time {
		margin-right: 14px;
		font-size: 16px;
		cursor: pointer;
		color: #84888f;
		padding: 4px 5px 3px;
		border-radius: 8px;
		width: 28px;
		height: 28px;

		&:hover {
			background-color: #e5e6eb;
		}
	}

	.chat-content-answer-created-time {
		font-size: 13px;
		color: #909399;
		margin-left: 12px;
		// margin-top: 4px;
	}

	.answer-tools-regenerate {
		font-size: 13px;
		border: 1px solid #ccc;
		padding: 2px 8px;
		text-align: center;
		border-radius: 12px;
	}

	.answer-tools-disabled {
		color: #c0c4cc;
		cursor: not-allowed;
	}

	// 思考状态样式
	.thinking-status,
	.thought-status {
		border-radius: 8px;
		display: inline-block;
	}

	// “正在思考中”卡片：仿 sikaoz 完整组合（白卡片 + 三点跳动 + 文字流光），主题色 #2563eb
	.thinking-indicator {
		display: flex;
		align-items: center;
		gap: 8px;
		font-size: 14px;
		animation: thinking-card-in 0.4s cubic-bezier(0.2, 0.9, 0.3, 1.2) both;
		transition: box-shadow 0.25s ease;
		padding: 6px 14px;
		background: #f1f5f9;
		border-radius: 20px;
	}

	// 卡片可点击（切换思考过程），hover 加深阴影给出手感
	.thinking-status:hover .thinking-indicator {
		// box-shadow: 0 4px 16px rgba(37, 99, 235, 0.22);
	}

	.thought-indicator {
		display: flex;
		align-items: center;
		gap: 6px;
		font-size: 14px;
		padding: 6px 14px;
		background: #f1f5f9;
		border-radius: 20px;
	}

	// 三点跳动
	.thinking-dots {
		display: inline-flex;
		align-items: center;
		gap: 4px;

		i {
			width: 6px;
			height: 6px;
			border-radius: 50%;
			background: #2563eb;
			animation: thinking-dot-bounce 1.2s infinite ease-in-out;
		}

		i:nth-child(2) {
			animation-delay: 0.15s;
		}

		i:nth-child(3) {
			animation-delay: 0.3s;
		}
	}

	// 文字流光
	.thinking-text {
		font-weight: 500;
		font-size: 14px;
		letter-spacing: 0.5px;
		background: linear-gradient(90deg, #a1a1b5 0%, #a1a1b5 40%, #2c3e50 50%, #a1a1b5 60%, #a1a1b5 100%);
		background-size: 200% 100%;
		-webkit-background-clip: text;
		background-clip: text;
		-webkit-text-fill-color: transparent;
		animation: thinking-shimmer 1.8s linear infinite;
	}

	// 已暂停：停止三点跳动与流光，文字转静态灰，弱化阴影
	.thinking-indicator.is-paused {
		// box-shadow: 0 2px 8px rgba(15, 23, 42, 0.08);

		.thinking-dots i {
			animation: none;
			opacity: 0.45;
			background: #94a3b8;
			display: none;
		}

		.thinking-text {
			animation: none;
			background: none;
			-webkit-text-fill-color: #2c3e50;
		}
	}

	.thought-text {
		font-weight: 500;
		font-size: 15px;
	}

	@keyframes thinking-dot-bounce {
		0%,
		80%,
		100% {
			transform: translateY(0) scale(0.8);
			opacity: 0.35;
		}
		40% {
			transform: translateY(-5px) scale(1);
			opacity: 1;
		}
	}

	@keyframes thinking-shimmer {
		0% {
			background-position: 150% 0;
		}
		100% {
			background-position: -50% 0;
		}
	}

	@keyframes thinking-card-in {
		from {
			opacity: 0;
			transform: translateY(8px) scale(0.96);
		}
		to {
			opacity: 1;
			transform: none;
		}
	}

	// 无障碍：用户偏好减少动效时停用思考动画
	@media (prefers-reduced-motion: reduce) {
		.thinking-dots i,
		.thinking-text,
		.thinking-indicator {
			animation: none !important;
		}
	}

	.content-icon {
		border-radius: 50%;
		width: 6px;
		height: 6px;
		background: #81858c;
		position: absolute;
		top: 14px;
		left: -2px;
	}

	/* 折叠功能样式 */
	.content-header {
		position: relative;
		cursor: pointer;
		padding: 8px 0 8px 12px;
		user-select: none;
		display: flex;
		align-items: center;
		border-radius: 4px;
		transition: 0.3s ease;
		margin-bottom: 0;
		color: #909399;
		font-size: 14px;
	}

	.collapse-icon {
		color: #909399;
		font-size: 12px;
		transition: 0.3s ease;
		margin-left: auto;
	}

	.el-icon-collapse {
		color: #2c2c2e;
		font-size: 14px;
	}

	.content-header:hover .collapse-icon {
		color: #606266;
	}

	.content-body {
		overflow: hidden;
	}

	/* 折叠动画 */
	.collapse-enter-active,
	.collapse-leave-active {
		transition: all 0.3s ease;
		max-height: 1000px;
		opacity: 1;
	}

	.collapse-enter,
	.collapse-leave-to {
		max-height: 0;
		opacity: 0;
	}

	.main-cont {
		color: #61666b;
		padding-left: 20px;
		border-left: 1px solid #e1e5ee;
		margin-bottom: -20px;
		padding-bottom: 10px;
	}

	// 打字指示器
	.typing-indicator {
		display: flex;
		align-items: center;
		margin-top: 10px;
	}

	.loading-dots {
		display: flex;
		align-items: center;
		margin-right: 8px;
	}

	.loading-dots .dot {
		width: 8px;
		height: 8px;
		background-color: #409eff;
		border-radius: 50%;
		margin: 0 2px;
		animation: loading 1.4s infinite ease-in-out both;
	}

	.loading-dots .dot:nth-child(1) {
		animation-delay: -0.32s;
	}

	.loading-dots .dot:nth-child(2) {
		animation-delay: -0.16s;
	}

	.loading-text {
		color: #909399;
		font-size: 14px;
	}

	.status-loading-text {
		display: inline-block;
		position: relative;
		animation: fade-in-out 2s cubic-bezier(0.4, 0, 0.2, 1) infinite;
	}

	@keyframes fade-in-out {
		from {
			opacity: 0.3;
		}
		to {
			opacity: 1;
		}
	}

	@keyframes loading {
		0%,
		80%,
		100% {
			transform: scale(0);
			opacity: 0.5;
		}
		40% {
			transform: scale(1);
			opacity: 1;
		}
	}

	.flex {
		display: flex;
	}
</style>
